import SelectItemWrapper from './SelectItem.styles';

type Props = {
    selectItemKey: string,
    selectItemClassName: string,
    selectItem: string,
    onSelectChange(evt: React.SyntheticEvent<HTMLLIElement>): void,
    isSelected: boolean
}

const SelectItem: React.FC<Props> = ({ selectItemKey, selectItemClassName, selectItem, onSelectChange, isSelected }) => {
    // console.log(selectItem + isSelected);
    return (
        <SelectItemWrapper
            key={selectItemKey}

            className={`${selectItemClassName} ${isSelected ? "selected" : ""}`}
            onClick={onSelectChange}
        >
            <span className="list-item" item-key={selectItemKey}>{selectItem}</span>

        </SelectItemWrapper>
    )
}

export default SelectItem;